import {
  VUE_APP_ILLION_TERMS_OF_USE_URL,
  VUE_APP_ILLION_PRIVACY_STATEMENT_URL,
} from 'public/settings';
import { EXTERNAL } from '@/constants/consents-link-types';

export const ILLION_AGREEMENT = {
  type: 'ILLION_AGREEMENT',
  optional: true,
  links: [
    {
      type: EXTERNAL,
      url: VUE_APP_ILLION_TERMS_OF_USE_URL,
      linkTextPath: 'termsAndConditionsLink',
    },
    {
      type: EXTERNAL,
      url: VUE_APP_ILLION_PRIVACY_STATEMENT_URL,
      linkTextPath: 'privacyPolicyLink',
    },
  ],
};

export default [ILLION_AGREEMENT];
